export interface CustomerData {
  gender: Gender | null
  firstname: string | null
  lastname: string | null
  email: string | null
  telephone: string | null
  dateOfBirth: Date | null
  location: Location | null
}

export interface Location {
  street: string | null
  detail: string | null
  zip: string | null
  cityName: string | null
  countryISO: string | null
  latitude: number | null
  longitude: number | null
}

export enum Gender {
  Female = 'female',
  Male = 'male',
  Unspecified = 'not applicable',
}
